/**
 * useAppNavigation — intent navigation for code running inside the shell
 * (proposal 0129). Symmetric with `@rapidsos/assemble-shell-runtime`'s hook of
 * the same name that modules use: both read the imperative controller the
 * headless `NavigationController` publishes on `window.__DATA_PLANE_NAV__`, with
 * a logged no-op fallback when it is not yet mounted.
 */

export interface AppNavigation {
  go: (intent: string, params?: Record<string, unknown>) => void;
  canGo: (intent: string) => boolean;
}

let warned = false;

const NOOP_NAVIGATION: AppNavigation = {
  go: (intent) => {
    if (!warned) {
      warned = true;
      console.warn(
        `[useAppNavigation] go("${intent}") is a no-op: NavigationController not mounted yet.`,
      );
    }
  },
  canGo: () => false,
};

function resolveController(): AppNavigation {
  const nav = (window as unknown as { __DATA_PLANE_NAV__?: AppNavigation }).__DATA_PLANE_NAV__;
  if (nav && typeof nav.go === 'function' && typeof nav.canGo === 'function') {
    return nav;
  }
  return NOOP_NAVIGATION;
}

export function useAppNavigation(): AppNavigation {
  return resolveController();
}
